import React, {useCallback} from 'react';
import {MODALS} from 'modules/modals/constants';
import dynamic from 'next/dynamic';
import {ModalLazyLoader} from 'components/ModalLazyLoader';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {actionSetConfirmationSource, actionSetRegistrationData} from 'modules/auth/slice';
import {hideModal} from 'modules/modals/thunks';
import {useRouter} from 'next/router';

const CloseConfirmationModal = dynamic(() => import('modules/auth/view/components/CloseConfirmationModal'), {
    loading: () => <ModalLazyLoader />,
});

export const CloseConfirmationDialog = () => {
    const dispatch = useAppDispatch();
    const router = useRouter();

    const handleConfirm = useCallback(() => {
        dispatch(actionSetConfirmationSource({}));
        dispatch(actionSetRegistrationData({birthdayDate: '', code: '', phone: '', email: ''}));
        dispatch(hideModal(MODALS.AUTH_CLOSE_CONFIRMATION.name));
        dispatch(hideModal(MODALS.AUTH_DIALOG.name));
        dispatch(hideModal(MODALS.PROFILE_PHONE_SMS.name));

        if (router.pathname.includes('/personal')) {
            router.push('/');
        }
    }, [router, dispatch]);

    const handleDiscard = useCallback(() => {
        dispatch(hideModal(MODALS.AUTH_CLOSE_CONFIRMATION.name));
    }, [dispatch]);

    return (
        <>
            <CloseConfirmationModal onClose={handleDiscard} onSubmit={handleConfirm} />
        </>
    );
};
